import React, { Component, Fragment } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import {
  Section,
  BoxLayoutSymetrical,
  BoxImageContent,
  BoxHashtag,
  BoxDiscover,
  BoxCTA,
} from 'components';
import './Methodology.scss';
import { BOX_TYPES } from 'config';
import { data } from './logic.js';

class Methodology extends Component {
  renderBoxes = loadedData =>
    data.map(item => (
      <Fragment key={`box-${item.id}`}>
        {item.type === BOX_TYPES.IMAGE_CONTENT && (
          <BoxImageContent
            additionalClass={'methodology__post-box'}
            item={{
              ...item,
              image: loadedData[item.image].childImageSharp.fluid,
            }}
          />
        )}
        {item.type === BOX_TYPES.DISCOVER && (
          <BoxDiscover
            link={item.link}
            headline={item.headline}
            description={item.description}
            backgroundColor={'gray-light'}
            id={item.id}
          />
        )}
        {item.type === BOX_TYPES.HASHTAG && (
          <BoxHashtag
            tag={item.tag}
            description={item.description}
            colors={item.colors}
            background={loadedData[item.background].childImageSharp.fluid}
            link={item.link}
            headingType={4}
            id={item.id}
          />
        )}
      </Fragment>
    ));

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            eventStorming: file(
              relativePath: { eq: "approach/room-with-glass-walls.png" }
            ) {
              childImageSharp {
                fluid(maxWidth: 480) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            lean: file(relativePath: { eq: "approach/team-room.jpg" }) {
              childImageSharp {
                fluid(maxWidth: 480) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            designThinking: file(
              relativePath: { eq: "approach/design-thinking.png" }
            ) {
              childImageSharp {
                fluid(maxWidth: 480) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            impactMapping: file(
              relativePath: { eq: "approach/team-meeting-preparation.jpg" }
            ) {
              childImageSharp {
                fluid(maxWidth: 480) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={loadedData => (
          <Section additionalClass={'methodology'} spaceless fullwidth>
            <BoxLayoutSymetrical mobileSlider>
              {this.renderBoxes(loadedData)}
              <BoxCTA name={'approach'} />
            </BoxLayoutSymetrical>
          </Section>
        )}
      />
    );
  }
}

export default Methodology;
